<div class="cf-chart-grid">
  <div class="cf-chart-card">
    <div class="cf-chart-card__header">
      <div class="cf-chart-card__icon">
        <mat-icon>assessment</mat-icon>
      </div>
      <div class="cf-chart-card__title-wrap">
        <p class="cf-chart-card__title">IGIC repercutido vs. soportado</p>
        <p class="cf-chart-card__sub">Evolución mensual</p>
      </div>
      <div class="cf-chart-card__header-actions">
        <mat-form-field subscriptSizing="dynamic" style="width:190px;">
          <mat-label>Meses</mat-label>
          <mat-select [formControl]="monthControl" multiple
            (selectionChange)="onChangeMonth($event)" #monthSelect>
            <mat-checkbox (change)='onSelectAll($event)' class="ps-3" [(ngModel)]="allMonthsSelected">
              Todos
            </mat-checkbox>
            <mat-select-trigger>
              <span *ngIf="allMonthsSelected" class="example-additional-selection">
                Todos
              </span>
              <span *ngIf="!allMonthsSelected" class="example-additional-selection">
                {{ getSelectedMonthsNames() }}
              </span>
            </mat-select-trigger>
            <mat-option *ngFor="let card of monthList; trackBy: trackByIndex" [value]="card.number">{{card.name}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div class="cf-chart-canvas-wrap">
      <canvas baseChart
        [type]="chartType"
        [data]="chartData"
        [options]="chartOptions"
        (chartHover)="chartHovered($event)"
        (chartClick)="chartClicked($event)">
      </canvas>
    </div>
  </div>

  <div class="cf-chart-card">
    <div class="cf-chart-card__header">
      <div class="cf-chart-card__icon cf-chart-card__icon--blue">
        <mat-icon>receipt</mat-icon>
      </div>
      <div class="cf-chart-card__title-wrap">
        <p class="cf-chart-card__title">Detalle IGIC</p>
        <p class="cf-chart-card__sub">Periodo seleccionado</p>
      </div>
    </div>

    <div class="rs-stat-group">
      <div class="rs-stat" style="background:rgba(77, 122, 0,.06);border-color:rgba(77, 122, 0,.25);width:auto;flex:1;min-width:200px;">
        <span class="rs-stat__label" style="color:#a86400;"><mat-icon>arrow_upward</mat-icon> IGIC repercutidos</span>
        <span class="rs-stat__value" style="color:#4d7a00;">{{ totalIncomesIgic | number:'1.2-2' }} €</span>
      </div>
      <div class="rs-stat rs-stat--red" style="width:auto;flex:1;min-width:200px;">
        <span class="rs-stat__label"><mat-icon>arrow_downward</mat-icon> IGIC soportados</span>
        <span class="rs-stat__value">{{ totalExpensesIgic | number:'1.2-2' }} €</span>
      </div>
      <div class="rs-stat" style="width:auto;flex:1;min-width:200px;">
        <span class="rs-stat__label">IGIC soportado bienes de inversión</span>
        <span class="rs-stat__value">{{ totalInvestmentIgic | number:'1.2-2' }} €</span>
      </div>
      <div class="rs-stat" style="width:auto;flex:1;min-width:200px;">
        <span class="rs-stat__label">IGIC de importación</span>
        <span class="rs-stat__value">{{ totalExpensesIgicImport | number:'1.2-2' }} €</span>
      </div>
      <div class="rs-stat rs-stat--total" style="width:auto;flex:1;min-width:200px;">
        <span class="rs-stat__label">Diferencia</span>
        <span class="rs-stat__value">{{ totalIgic | number:'1.2-2' }} €</span>
      </div>
    </div>
  </div>
</div>
